{
  "appSwitcher.additionalCapabilities": "Additional capabilities",
  "appSwitcher.allApps": "All apps",
  "appSwitcher.andManyMore": "and many more",
  "appSwitcher.closeSearch": "Close search",
  "appSwitcher.exploreMoreFeatures": "Explore more features",
  "appSwitcher.findApps": "Find EcoOnline apps",
  "appSwitcher.noResults": "No results found",
  "appSwitcher.switchProduct": "EcoOnline apps",
  "navbar.ad.bodyText": "Expanding our capabilities across your organisation to provide comprehensive safety and sustainability solutions.",
  "navbar.ad.headerText": "Move from compliance to predictability and protect your people and the planet",
  "navbar.back": "Back",
  "navbar.closeSearch": "Close search",
  "navbar.closeSideNav": "Close navigation",
  "navbar.guest": "Guest",
  "navbar.help": "Help",
  "navbar.home": "Home",
  "navbar.logOut": "Log out",
  "navbar.mainContent": "Main Content",
  "navbar.menu": "Menu",
  "navbar.search": "Search",
  "navbar.skipTo": "Skip to",
  "navbar.openSideNav": "Open navigation",
  "navbar.opensInNewTab": "opens in new tab",
  "navbar.yourAccount": "Your account"
}
